import { RouteRecordRaw } from "vue-router"

export const checkRoutes: RouteRecordRaw[] = [
  {
		path: "/parenting-detail",
		component: () => import("@/views/check/parentingDetail.vue"),
	},
	{
		path: "/parenting-ranking",
		component: () => import("@/views/check/parenntRankingList/index.vue"),
		redirect: "/parenting-ranking/know",
		children: [
			{
				path: "/parenting-ranking/know",
				component: () => import("@/views/check/parenntRankingList/knowRankingList.vue")
			},
			{
				path: "/parenting-ranking/badge",
				component: () => import("@/views/check/parenntRankingList/badgeRankingList.vue")
			},
		]
	},
	{
		path: "/check-iMaths-ranking",
		component: () => import("@/views/check/IMathsRankingList/index.vue"),
	},
	{
		path: "/art-rankingList",
		component: () => import("@/views/check/art/rankingList.vue"),
	},
	{
		path: "/art-rankingDetail",
		component: () => import("@/views/check/art/rankingDetail.vue"),
	},
]
